import React, { Fragment, useContext, useEffect, useState } from "react";
// Provider
import {
  AppContext,
  LOG_IN_SUCCESS,
  LOG_IN_FAILURE,
  SIGN_UP_REQUEST,
  LOG_OUT_SUCCESS,
  MENU_SET_ALL,
  SET_APP_ALL,
  SET_USER_HEALTH,
  socketManager,
  SocketCommand,
} from "../../components/AppProvider";

import {
  setCookie,
  getCookie,
  setExpire,
  setCookieWs,
  getCookieWs,
  getCookieEvent,
  lastLoginInfo,
} from "../../modules/utils/cookie";
// Utils
import { _O, _CHECK } from "../../modules/utils";

// UI
import {
  ContainerNew,
  openLayerFn,
  MenuNone,
  AlertPopup,
  InputPopup,
  openAlertPopup,
  closeLayerFn,
} from "../Layout";

import {
  PostApi101,
  PostApi109,
  PostApi1902,
  PostApi1910,
  PostApi1913,
  PostApi1930,
  PostApi1931,
  PostApiLoginLog,
} from "../../modules/network/padoPost";

import { AlertLayer, ConfirmLayer } from "../../components/UI/Dialog";

import { sha256 } from "js-sha256";
import { _CFG } from "../../modules/config";
import TermsPopup from "../Company/TermsDetail/TermsPopup";
import AuthAgreement from "../Company/TermsDetail/AuthAgreement";
import TermsViewer from "../Company/TermsDetail/TermsViewer";
import { ExistIdLayer } from "../common/Modal/ExistIdLayer";
import { userHabit } from "../../modules/utils/UserHabit";
import { NativeAction } from "../../modules/utils/HandleWs";

let URL = [
  "/",
  "/SM",
  "/sm/bp/input",
  "/sm/bs/input",
  "/eocs",
  "/surround",
  "/pmr",
  "/proof/apply",
];

export default (props) => {
  const { cfg, auth, dispatch, phonecfg, userinfo } = useContext(AppContext);

  const [loginSuccess, setLoginSuccess] = useState(false);
  const [isAutoLogin, setIsAutoLogin] = useState(true);
  const [dupList, setDupList] = useState("");
  const [attctNo, setAttctNo] = useState("");
  const [joinInfo, setJoinInfo] = useState({});

  const [inputs, setInputs] = useState({
    email: "",
    password: "",
    retUrl: props.match.params.retUrl,
  });

  const { retUrl } = inputs;

  const handleLogin = () => {
    // handleChange();
    if ($("input[name='email']").val().trim().length === 0) {
      // handleAlert('확인', '전화번호 또는 이메일을 입력해 주세요.');
      handleAlert("확인", "이메일을 입력해 주세요.");
    } else if (!_CHECK.EmailCheck($("input[name='email']").val())) {
      handleAlert("확인", "이메일 형식에 맞게 입력해 주세요.");
    } else if ($("input[name='password']").val().trim().length === 0) {
      handleAlert("확인", "비밀번호를 입력해 주세요.");
    } else {
      handleRequest101(handleConfirm);
    }
  };

  const handleRequest101 = () => {
    // 1차 입력한 그대로
    // 2차 trim
    const newPassword = sha256(
      $("input[name='email']").val().trim() +
        "eocs" +
        $("input[name='password']").val()
    );

    PostApi101(
      phonecfg,
      cfg,
      $("input[name='email']").val().trim(),
      newPassword,
      "",
      "000"
    )
      .then((res) => {
        if (res.resultCode === "000") {
          console.log("test11111");
          setLoginSuccess(true);
          handleLoginSuccess(res);
          setCookie("lastLoginChannel", "000", 365);
          loginLogInterface(res.resultList[0], phonecfg, cfg, "I", "M", "000");
        } else {
          reHandleRequest101();
        }
        socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {
          login: "in",
          userToken: res.resultList[0].userToken.toString(),
        });
      })
      .catch((err) => {
        setLoginSuccess(false);
        // handleLoginFail();
      });
  };

  const reHandleRequest101 = () => {
    const newPassword = sha256(
      $("input[name='email']").val() +
        " " +
        "eocs" +
        $("input[name='password']").val()
    );

    PostApi101(
      phonecfg,
      cfg,
      $("input[name='email']").val() + " ",
      newPassword,
      "",
      "000"
    )
      .then((res) => {
        if (res.resultCode === "000") {
          setLoginSuccess(true);
          handleLoginSuccess(res);
          setCookie("lastLoginChannel", "000", 365);
          loginLogInterface(res.resultList[0], phonecfg, cfg, "I", "M", "000");
        } else {
          setLoginSuccess(false);
          handleLoginFail();
        }
      })
      .catch((err) => {
        setLoginSuccess(false);
        // handleLoginFail();
      });
  };

  const setUserHlthInfo = (userinfo) => {
    PostApi1902(userinfo, cfg, phonecfg)
      .then((res) => {
        if (res.resultMsg === "SUCCESS") {
          if (res.result) {
            dispatch({ type: SET_USER_HEALTH, data: res.result });
          }
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const request1910 = (userinfo, cardType) => {
    PostApi1910(userinfo, cfg, phonecfg, cardType)
      .then((res) => {
        if (res.resultMsg === "SUCCESS") {
          let data = res.result;
          if (data.length > 0)
            dispatch({ type: MENU_SET_ALL, menutype: cardType, data: data });
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const request1913 = (userinfo) => {
    PostApi1913(userinfo, cfg, phonecfg)
      .then((res) => {
        if (res.resultMsg === "SUCCESS") {
          let data = res.result;
          dispatch({ type: SET_APP_ALL, data: data });
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleLoginFail = () => {
    dispatch({ type: LOG_IN_FAILURE });
    handleAlert(
      "확인",
      "아이디 또는 비밀번호가 틀립니다.<br />아이디와 비밀번호를 확인해 주세요"
    );
    $("input[name='password']").val("");
  };

  const handleLoginSuccess = (res) => {
    dispatch({
      type: LOG_IN_SUCCESS,
      data: res.resultList[0],
      isAutoLogin: isAutoLogin,
    });
    socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {
      login: "in",
      userToken: res.resultList[0].userToken.toString(),
    });
    request1910(res.resultList[0], "");
    request1913(res.resultList[0]);
    setUserHlthInfo(res.resultList[0]);

    setCookieWs({
      isAutoLogin: isAutoLogin,
      signUpChannel: "000",
      userEmail: res.resultList[0].userEmail,
    });

    if (
      phonecfg.phoneOS === "IOS" &&
      parseInt(phonecfg.version.split(".")[2]) > 13
    ) {
      NativeAction(phonecfg, "login", "in");
    }

    // 전체 가져오기 수정 필요
    if (res.resultList[0].isAuthOk == "0") {
      console.log("loginSuccess ::: ", loginSuccess);
      // 향후 수정 필요 임시임(DSRYU) 메세지 매번 보여줄 필요 없음 처리
      $("#exchangeTargetLogin").attr("id", "welcomeLogin");
      handleAlert("확인", `케어포미에 오신 것을 환영합니다.`);
      // 로그인 처리는 여기에++++++
    } else {
      // 로그인 이후 본인인증 여부에 따라
      $("#exchangeTargetLogin").attr("id", "welcomeLogin");
      _O.OpenMenu("/membership/certification");
    }
  };

  const handleLoginSuccess500 = (res) => {
    // dispatch({ type: LOG_IN_SUCCESS, data: res.resultList[0], isAutoLogin: isAutoLogin});
    dispatch({
      type: LOG_IN_SUCCESS,
      data: res.loginInfo[0],
      isAutoLogin: isAutoLogin,
    });
    socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {
      login: "in",
      userToken: res.loginInfo[0].userToken.toString(),
    });
    request1910(res.loginInfo[0], "");
    request1913(res.loginInfo[0]);
    setUserHlthInfo(res.loginInfo[0]);
    $("#exchangeTargetLogin").attr("id", "welcomeLogin");
    handleAlert("확인", `케어포미에 오신 것을 환영합니다.`);

    if (
      phonecfg.phoneOS === "IOS" &&
      parseInt(phonecfg.version.split(".")[2]) > 13
    ) {
      NativeAction(phonecfg, "login", "in");
    }

    loginLogInterface(res.resultList[0], phonecfg, cfg, "I", "M", "500");
    setCookieWs({
      isAutoLogin: isAutoLogin,
      signUpChannel: "500",
      userEmail: res.loginInfo[0].userId,
    });
  };

  // 다이얼로그 [[
  const [dialog, setDialog] = useState({
    title: "",
    msg: "",
  });

  const handleAlert = (title, msg) => {
    setDialog({
      title: title,
      msg: msg,
    });

    openLayerFn($(".alert-layer"));
  };

  const handleConfirm = (title, msg) => {
    setDialog({
      title: title,
      msg: msg,
    });

    openLayerFn($(".confirm-layer"));
  };

  const handleConfirmConfirmCB = () => {
    if (auth) {
      // 로그아웃 후 메인화면 이동
      dispatch({ type: LOG_OUT_SUCCESS });
      socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {
        login: "out",
        userToken: "",
      });
      let idx = !retUrl ? 0 : parseInt(retUrl);

      if (idx != 9) {
        _O.Open(URL[idx]);
      } else {
        _O.Open("/");
      }
    }
  };
  const handleConfirmCancelCB = () => {
    _O.OpenMenu("/");
  };

  const handleAlertCB = () => {
    console.log("test::::: ", loginSuccess);
    if (loginSuccess) {
      // 메인화면 이동
      let idx = !retUrl ? 0 : parseInt(retUrl);

      if (idx != 9) {
        _O.Open(URL[idx]);
      } else {
        _O.Open("/");
      }
    }
  };

  const settingAutoLogin = () => {
    setIsAutoLogin($("#setAutoLogin").is(":checked"));
  };

  const appleLoginAf = (userEmail, userName, UID, signUpChannel) => {
    // setCookieWs({'isAutoLogin': isAutoLogin, 'signUpChannel':'600'});
    if (userEmail && userEmail != null) {
      _O.Open(
        "/membership/snsLogin/" +
          userEmail +
          "/" +
          userName +
          "/" +
          UID +
          "/" +
          signUpChannel
      );
    } else {
      _O.Open("/membership/appleLogin/" + UID + "/" + signUpChannel);
    }
  };

  const goSnsLogin = (param) => {
    // setCookie("isAutologin", isAutoLogin, 365);

    if (param === "KAKAO") {
      setCookie("signUpChannel", "400", 1);
      setCookieWs({ isAutoLogin: isAutoLogin, signUpChannel: "400" });
      window.location.href = "ep://login/kakao";
    }

    if (param === "NAVER") {
      setCookie("signUpChannel", "100", 1);
      setCookieWs({ isAutoLogin: isAutoLogin, signUpChannel: "100" });
      window.location.href = "ep://login/naver";
    }

    if (param === "APPLE") {
      setCookie("signUpChannel", "600", 1);
      socketManager(SocketCommand.LOGIN_APPLE, appleLoginAf, {});
    }
  };

  const noSpaceInput = () => {
    const str_space = /\s/;

    if (str_space.exec($("input[name='email']").val())) {
      $("input[name='email']").val(
        $("input[name='email']").val().replace(" ", "")
      );
    }
  };

  useEffect(() => {
    // openWebSocket();
    if (retUrl) console.log("로그인 화면 들어옴 : [", retUrl, "]");
    const autologin = getCookie("isAutologin");
    $("#setAutoLogin").prop("checked", autologin === "false" ? false : true);

    if (props.match.params.userId) {
      if (props.match.params.userId === "LOGOUT") {
        openLayerFn($(".alert-layer-logout"));
      } else {
        $("input[name='email']").val(props.match.params.userId);
      }
    } else {
      // $("input[name='email']").val(getCookie("userEmail"));
      if (getCookie("lastLoginChannel")) {
        if (getCookie("lastLoginChannel").toString() === "000") {
          $("input[name='email']").val(getCookie("userEmail"));
        }
      }

      getCookieWs(lastLoginInfo);
    }

    // 폰토큰 없는경우
    if (
      !getCookie("phoneToken") ||
      getCookie("phoneToken") === "123" ||
      getCookie("phoneToken") === "undefined"
    ) {
      if (phonecfg.phoneOS == "IOS") {
        // socketManager(SocketCommand.GET_PHONE_INFO_OLD, undefined);
        socketManager(SocketCommand.GET_PHONE_INFO, undefined);
        // socketManager(SocketCommand.GET_GPS_INFO, undefined);
      } else {
        // 임시방편
        socketManager(SocketCommand.GET_PHONE_INFO_OLD, undefined);
        // socketManager(SocketCommand.GET_PHONE_INFO, undefined);
      }
    }
  }, [props.match.params.userId]);

  const goRegist = (signUpChannel) => {
    setCookie("signUpChannel", signUpChannel, 1);
    if (signUpChannel === "000") {
      openLayerFn($("#termsPopup"));
      userHabit(phonecfg, "RG100_P01");
    } else {
      openLayerFn($("#inputPopup"));
      // userHabit(phonecfg, 'LI104');
    }
  };

  const registToAttctNo = (attctNoParam) => {
    let attctNoVal = "";

    if (attctNoParam) {
      attctNoVal = attctNoParam;
    } else {
      attctNoVal = attctNo;
    }

    if (attctNoParam != 0) {
      PostApi1930(userinfo, cfg, phonecfg, "N", attctNoVal)
        .then((res) => {
          if (res.resultCode === "000") {
            setJoinInfo(res.joinInfo);
            closeLayerFn($("#inputPopup"));
            openLayerFn($("#termsPopup"));
            attctNoVal = "";
          } else if (res.resultCode === "003") {
            setDupList(res.loginInfo);
            openLayerFn($("#existLayer"));
          } else if (res.resultCode === "004") {
            setLoginSuccess(true);
            handleLoginSuccess500(res);

            setTimeout(() => {
              socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {
                login: "in",
                userToken: res.resultList[0].userToken.toString(),
              });
            }, 2000);
          } else {
            openAlertPopup("인증번호를 확인하세요.");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      PostApi1931(userinfo, cfg, phonecfg, attctNoVal, joinInfo)
        .then((res) => {
          if (res.resultMsg === "SUCCESS") {
            // alert("연동에 성공하였습니다.");
            // handleConfirm("", "연동에 성공하였습니다.")

            if (res.resultCode === "000") {
              setLoginSuccess(true);
              handleLoginSuccess500(res);

              setTimeout(() => {
                socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {
                  login: "in",
                  userToken: res.loginInfo[0].userToken.toString(),
                });
              }, 2000);
            } else {
              handleConfirm("", "로그인 실패");
            }
          } else {
            openAlertPopup("인증번호 등록에 실패하였습니다.");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  // useEffect(() => {
  //     getCookieWs(lastLoginInfo);
  // }, []);
  return (
    <Fragment>
      <ContainerNew
        Title={"로그인"}
        dark={true}
        leftMenu={MenuNone}
        rightMenu={MenuNone}
      >
        <div className="login-pw-box repver2">
          {/* <a href={void 0} onClick={(e) => handleLogoutConfirm('확인', '로그아웃 하겠습니까?')} className="btn-logout"></a>	 */}

          <div className="pw-inp-box">
            {/*<span>일반 로그인</span>*/}

            <div className="ninp">
              <input
                type="text"
                name="email"
                // value={email}
                autoComplete="email"
                placeholder="아이디"
                // onChange={handleChange}
                onChange={noSpaceInput}
              />
              <input
                type="password"
                name="password"
                // value={password}
                autoComplete="current-password"
                placeholder="비밀번호"
                // onChange={handleChange}
              />
            </div>
            <div className="btn">
              <a href={void 0} className="" onClick={(e) => handleLogin()}>
                로그인
              </a>
            </div>

            <div className="login-area-bt-join">
              {/* <a href={void 0} onClick={(e) => _O.OpenMenu("/membership/findID")}>아이디 찾기</a> */}
              <a onClick={(e) => _O.OpenMenu("/membership/findEmail")}>
                아이디/비밀번호 찾기
              </a>
              {/* <a onClick={(e) => _O.OpenMenu("/membership/findEmail")}>비밀번호 찾기</a> */}
              <a onClick={(e) => goRegist("000")}>회원가입</a>
              <a>
                자동로그인{" "}
                <input
                  type="checkBox"
                  id="setAutoLogin"
                  onClick={settingAutoLogin}
                  style={{ verticalAlign: "bottom" }}
                />
              </a>
            </div>

            <div className="sns-icons-area">
              {phonecfg.phoneOS === "IOS" &&
                parseInt(phonecfg.version.split(".")[2]) >= 5 && (
                  <>
                    <div>
                      <ul>
                        <li>
                          <a
                            className="sns1"
                            onClick={() => goSnsLogin("KAKAO")}
                          ></a>
                          <LastLogin signUpChannel="400" />
                        </li>
                        <li>
                          <a
                            className="sns2"
                            onClick={() => goSnsLogin("NAVER")}
                          ></a>
                          <LastLogin signUpChannel="100" />
                        </li>
                        <li>
                          <a
                            className="sns4"
                            onClick={() => goSnsLogin("APPLE")}
                          ></a>
                          <LastLogin signUpChannel="600" />
                        </li>
                      </ul>
                    </div>
                    <div>
                      <a>SNS 로그인</a>
                    </div>
                  </>
                )}

              {phonecfg.phoneOS != "IOS" && (
                <>
                  <div>
                    <ul>
                      <li>
                        <a
                          className="sns1"
                          onClick={() => goSnsLogin("KAKAO")}
                        ></a>
                        <LastLogin signUpChannel="400" />
                        {/* {'400' == getCookie('signUpChannel') && <p>마지막으로 로그인한 계정입니다.</p>} */}
                      </li>
                      <li>
                        <a
                          className="sns2"
                          onClick={() => goSnsLogin("NAVER")}
                        ></a>
                        <LastLogin signUpChannel="100" />
                      </li>
                    </ul>
                  </div>
                  <div>
                    <a>SNS 로그인</a>
                  </div>
                </>
              )}

              <div style={{ position: "relative" }}>
                <a
                  onClick={() => _O.Open("/membership/help/1")}
                  style={{ borderBottom: "1px solid #999" }}
                >
                  로그인 시 도움이 필요한가요?
                </a>
                <LastLogin signUpChannel="500" />
              </div>
            </div>
          </div>
        </div>
      </ContainerNew>

      <AlertLayer
        title={dialog.title}
        msg={dialog.msg}
        handleConfirmCB={handleAlertCB}
      />

      <ConfirmLayer
        title={dialog.title}
        msg={dialog.msg}
        handleCancelCB={handleConfirmCancelCB}
        handleConfirmCB={handleConfirmConfirmCB}
      />

      <TermsPopup />
      <AuthAgreement registToAttctNo={registToAttctNo} />
      <AlertPopup />
      <TermsViewer />

      <ExistIdLayer dupList={dupList} type="REG" />
      <InputPopup
        handleConfirm={handleConfirm}
        registToAttctNo={registToAttctNo}
        setAttctNo={setAttctNo}
      />
    </Fragment>
  );
};

export const LastLogin = (props) => {
  const { signUpChannel } = props;
  return (
    <Fragment>
      {
        getCookie("lastLoginChannel") &&
          getCookie("lastLoginChannel").toString() ==
            signUpChannel.toString() && (
            <p className="lastLoginInfo">마지막으로 로그인한 계정입니다.</p>
          )
        // :   getCookie('signUpChannel') && getCookie('signUpChannel').toString() == signUpChannel.toString() && <p className="lastLoginInfo">마지막으로 로그인한 계정입니다.</p>
      }
    </Fragment>
  );
};

// logType : I(로그인) O(로그아웃)
// procType : A(자동) M(수동)
// scrptTypeCd : signUpChannel
export const loginLogInterface = (
  userinfo,
  phonecfg,
  cfg,
  logType,
  procType,
  scrptTypeCd
) => {
  if (logType === "I") {
    PostApiLoginLog(userinfo, phonecfg, cfg, logType, procType, scrptTypeCd)
      .then((res) => {
        if (res.resultCode === "000") {
        } else {
        }
      })
      .catch((err) => {
        // handleLoginFail();
      });
  } else {
    PostApi109(userinfo, phonecfg, cfg, logType, procType, scrptTypeCd)
      .then((res) => {
        if (res.resultCode === "000") {
        } else {
        }
      })
      .catch((err) => {
        // handleLoginFail();
      });
  }
};

// loginLogInterface(res.resultList[0], phonecfg, cfg, "I", "M", "000");
// loginLogInterface(userinfo, phonecfg, cfg, "O", "M", getCookie("signUpChannel"));
